// extracted by mini-css-extract-plugin
export var disabled = "_s3-0";